export default __webpack_public_path__ + "static/button-anatomy-dark-6e92e19be721da6bedc90d2a11acbc80b246d2e098dada09cc061454c83c2a3e.png";